import {Type} from '@angular/core';
import {ProjectUserManagementComponent} from './project-user-management/project-user-management.component';
import {ProjectProviderCommunicationComponent} from './project-provider-communication/project-provider-communication.component';
import {ProjectChapterType} from '@frontend/shared';

export const CHAPTERS_IN_DEVELOPMENT: ProjectChapterType[] = [
  ProjectChapterType.NOT_IMPLEMENTED,
] as const;

export interface SpecialOption {
  id: string;
  title: string;
  icon: string;
  content: Type<object>;
}

export const SPECIAL_OPTION_IDS = {
  USER_MANAGEMENT: 'user-management',
  PROVIDER_COMMUNICATION: 'provider-communication',
} as const;

export const DEFAULT_SPECIAL_OPTIONS: SpecialOption[] = [
  {
    id: SPECIAL_OPTION_IDS.USER_MANAGEMENT,
    title: 'userManagement',
    icon: 'pi pi-users',
    content: ProjectUserManagementComponent,
  },
  {
    id: SPECIAL_OPTION_IDS.PROVIDER_COMMUNICATION,
    title: 'providerCommunication',
    icon: 'pi pi-users',
    content: ProjectProviderCommunicationComponent,
  },
];
